import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import { useState } from 'react';
import { SecurityRatingGlobalScoreMaturityEnum } from 'services/common/SecurityRatingUtils';
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';
import SecurityRatingCyberMaturityModal from './SecurityRatingCyberMaturityModal';
import SecurityRatingMaturityLabel from './SecurityRatingMaturityLabel';
import SecurityRatingScoreVariation from './SecurityRatingScoreVariation';
import { isNumber } from 'lodash';

const SecurityRatingGlobalScore = ({ data }) => {
  const { classes } = useStyles();

  const [isCyberMaturityModalOpen, setCyberMaturityModalOpen] = useState(false);

  return data && (
    <>
      <div className={classes.globalMaturityWrapper}>
        <div className={classes.globalMaturityTitle}>
          {i18next.t(`securityRating.cyberMaturity`)}
          <span className={classes.moreDetailsBtn} onClick={() => setCyberMaturityModalOpen(true)}>
            {i18next.t("moreDetails")}<EAIcon icon="call_made" />
          </span>
        </div>
        <div className={classes.globalMaturityChart}>
          <EAIcon icon={`security-rating/gauge_${SecurityRatingGlobalScoreMaturityEnum[data.score.maturity]}`} />
          <div className={classes.globalMaturityScore}>
            <span className="score">{data.score.value}</span>
            <span className="max-score">/1000</span>
          </div>
        </div>
        <div className={classes.globalScoreDivider}></div>
        <div className={classes.maturityWrapper}>
          {isNumber(data.score?.delta) && data.score.delta > 0 && <SecurityRatingScoreVariation delta={data.score.delta} trend={data.score.trend} />}
          <SecurityRatingMaturityLabel maturity={data.score.maturity} />
        </div>
      </div>
      <SecurityRatingCyberMaturityModal
        isOpen={isCyberMaturityModalOpen}
        data={data}
        onClose={() => setCyberMaturityModalOpen(false)} 
      />
    </>
  );
};

export default SecurityRatingGlobalScore;
